<template>
    <div>
        <page-header :title="$t('payments.title')" />
        <div class="payments-wrapper">
            <p class="header-text">{{ $t('payments.headerText') }}</p>
            <div v-if="constants.platform == 'mobile'">
                <ion-button v-if="!processingPayment && !success" style="display:inline-block" @click="handleInAppPurchase">
                    {{ $t('plans.activate') }}
                </ion-button>
                <ion-spinner class="spinner" v-if="processingPayment" color="primary"></ion-spinner>
                <h3 v-if="success">{{ $t('payments.success') }}</h3>
            </div>
            <ion-grid v-if="constants.platform == 'desktop'" class="ion-text-start ion-margin-start ion-margin-end">
                <ion-row class="ion-justify-content-center ion-margin-top">
                    <ion-col class="ion-padding stripe" size="6">
                        <img v-if="!selectedPaymentWay" @click="selectedPaymentWay = 'stripe'" src="@/assets/creditcards.png" />
                        <div class="ion-text-center" v-show="selectedPaymentWay === 'stripe'">
                            <div ref="card"></div>
                            <ion-button v-if="!processingPayment && !success" style="display:inline-block" @click="checkoutWithStripe">
                                {{ $t('plans.activate') }}
                            </ion-button>
                            <ion-spinner class="spinner" v-if="processingPayment" color="primary"></ion-spinner>
                            <h3 v-if="success">{{ $t('payments.success') }}</h3>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-center ion-margin-top">
                    <ion-col v-if="!selectedPaymentWay" class="ion-padding western-union" size="6">
                        <img v-if="!selectedPaymentWay" @click="goToContact" src="@/assets/westernunion-logo.png" />
                    </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-center ion-margin-top">
                    <ion-col v-if="!selectedPaymentWay" class="ion-padding western-union" size="6">
                        <img v-if="!selectedPaymentWay" @click="contactReseller" src="@/assets/reseller.png" />
                    </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-center ion-margin-top">
                    <ion-col v-if="!selectedPaymentWay || selectedPaymentWay == 'paypal'" class="ion-padding paypal-wrapper" size="6">
                        <PayPal
                            class="paypal"
                            @payment-authorized="handlePaypalAuthorized"
                            :amount="amount"
                            currency="USD"
                            :client="client"
                            :env="paypalEnv"
                            :button-style="paypalButtonStyle"
                        >
                        </PayPal>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <ad-leaderboard />
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AdLeaderboard from '@/components/AdLeaderboard'
import AxiosController from '@/controllers/AxiosController'
import PayPal from 'vue-paypal-checkout'
import { constants } from '../constants'
import { isMobile } from 'mobile-device-detect'

let stripe = Stripe(constants.stripeKey),
    elements = stripe.elements(),
    card = undefined

export default {
    name: 'payments',
    components: { PageHeader, PayPal, AdLeaderboard },
    data() {
        return {
            selectedPaymentWay: '',
            loading: false,
            successUrl: '/user/me',
            cancelUrl: '/',
            client: {
                sandbox: `${constants.paypalSandboxClientID}`,
                production: `${constants.paypalProductionClientID}` //We need to get this
            },
            amount: '',
            paypalButtonStyle: {
                label: 'checkout',
                size: 'responsive',
                shape: 'pill',
                color: 'silver'
            },
            constants,
            paypalEnv: `${constants.paypalEnv}`,
            processingPayment: false,
            isMobile,
            success: false
        }
    },
    mounted() {
        if (card) {
            card.destroy()
        }

        card = elements.create('card', {
            hidePostalCode: true,
            style: {
                base: {
                    iconColor: '#000000',
                    color: '#000000',
                    backgroundColor: '#ffffff',
                    lineHeight: '40px',
                    fontWeight: 300,
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSize: '15px',

                    '::placeholder': {
                        color: '#CFD7E0'
                    }
                }
            }
        })
        card.mount(this.$refs.card)

        this.amount = this.$route.query.plan == 1 ? '150.00' : '100.00'
    },
    methods: {
        goToContact: function() {
            this.$router.push('/contact')
        },
        contactReseller: function() {
            this.$router.push('/contact-reseller')
        },
        checkoutWithStripe: function() {
            this.processingPayment = true
            const plan = this.$route.query.plan
            const self = this
            stripe.createToken(card).then(function(result) {
                if (result.error) {
                    self.$snotify.error(result.error.message).on('hidden', () => {
                        self.$store.dispatch('clearError')
                    })
                    self.processingPayment = false
                } else {
                    AxiosController.post('/stripe', {
                        plan,
                        data: result.token
                    }).then(() => {
                        self.processingPayment = false
                        self.$store.dispatch('setHasAccess', true)
                        self.success = true
                        setTimeout(() => {
                            self.$router.push('/user/me')
                        }, 3000)
                    })
                }
            })
        },
        handlePaypalAuthorized: function(data) {
            const plan = this.$route.query.plan
            const self = this
            AxiosController.post('/paypal', { plan, data }).then(response => {
                if (response.data === 'success') {
                    self.$store.dispatch('setHasAccess', true)
                    self.$router.push('/user/me')
                } else {
                    self.$snotify.error('Payment failure').on('hidden', () => {
                        self.$store.dispatch('clearError')
                    })
                }
            })
        },
        handleInAppPurchase: function() {
            const plan = this.$route.query.plan
            const self = this
            self.processingPayment = true
            const productId = `com.sharekomry.plan${plan}`
            inAppPurchase
                .getProducts([productId])
                .then(function(products) {
                    inAppPurchase
                        .subscribe(productId)
                        .then(function(data) {
                            // inAppPurchase.consume(data.productType, data.receipt, data.signature)
                            AxiosController.post(process.env.CORDOVA_PLATFORM === 'ios' ? '/applestore' : '/playstore', {
                                plan,
                                productId,
                                data: data.receipt
                            }).then(response => {
                                if (response.data === 'success') {
                                    self.processingPayment = false
                                    self.$store.dispatch('setHasAccess', true)
                                    self.success = true
                                    setTimeout(() => {
                                        self.$router.push('/user/me')
                                    }, 3000)
                                } else {
                                    self.processingPayment = false
                                    self.$snotify.error('Payment failure').on('hidden', () => {
                                        self.$store.dispatch('clearError')
                                    })
                                }
                            })
                        })
                        .catch(function(err) {
                            self.processingPayment = false
                        })
                })
                .catch(function(err) {
                    self.processingPayment = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.payments-wrapper {
    min-height: 40vh;

    .header-text {
        padding: 15px 20px;
        font-size: 13px;
    }

    ion-button {
        margin: 24px 0;
        --border-radius: 40px;
    }
}

.stripe {
    position: relative;
    height: 15vh;
    img {
        cursor: pointer;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
    }
}

.western-union {
    position: relative;
    height: 15vh;
    img {
        cursor: pointer;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
    }
}

.paypal-wrapper {
    position: relative;
    height: 15vh;
    .paypal {
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
    }
}

.spinner {
    display: inline-block;
    position: relative;
    top: 20px;
}

@media (min-width: 768px) {
    .payments-wrapper {
        .header-text {
            font-size: 20px;
        }
    }
}
</style>
